module.exports = __webpack_public_path__ + "img/ddesk.99165b8a.png";